export const ID_FILTER_SEARCH = "search";
export const ID_FILTER_TYPE = 'type';
export const ID_FILTER_MODE = 'mode';
export const ID_FILTER_AMOUNTMODIFIED = 'amount-modified';
export const ID_FILTER_CREATIONDATEFROM = 'creation-date-from';
export const ID_FILTER_CREATIONDATETO = 'creation-date-to';
export const ID_FILTER_MODIFICATIONDATEFROM = 'modification-date-from';
export const ID_FILTER_MODIFICATIONDATETO = 'modification-date-to';